var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Cart",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-cart","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path fill="none" d="M193.6 211.8c-4.7 0-8.6 3.9-8.6 8.7s3.9 8.7 8.6 8.7 8.6-3.9 8.6-8.7-3.9-8.7-8.6-8.7z"/>
  <path fill="none" d="M100.4 211.8c-4.7 0-8.6 3.9-8.6 8.7s3.9 8.7 8.6 8.7c4.7 0 8.6-3.9 8.6-8.7s-3.9-8.7-8.6-8.7z"/>
  <path d="M61.6 53L50.8 7H0v11h42.2l9.5 40.4L74.1 181h149.5l25.1-128H61.6zm153.1 117H83.1L63.7 64h171.7l-20.7 106z"/>
  <path d="M100.4 199.8c-11.3 0-20.4 9.3-20.4 20.7s9.2 20.7 20.4 20.7 20.4-9.3 20.4-20.7-9.1-20.7-20.4-20.7zm0 29.3c-4.7 0-8.6-3.9-8.6-8.7s3.9-8.7 8.6-8.7c4.7 0 8.6 3.9 8.6 8.7s-3.9 8.7-8.6 8.7z"/>
  <path d="M193.6 199.8c-11.3 0-20.4 9.3-20.4 20.7s9.2 20.7 20.4 20.7 20.4-9.3 20.4-20.7-9.1-20.7-20.4-20.7zm0 29.3c-4.7 0-8.6-3.9-8.6-8.7s3.9-8.7 8.6-8.7 8.6 3.9 8.6 8.7-3.9 8.7-8.6 8.7z"/>
  <polygon fill="none" points="63.7,64 83.1,170 214.7,170 235.5,64"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/cart.svg